import { FunctionComponent } from "react";
import Biography from "./pages/Biography";
import Home from "./pages/Home";
import Paintings from "./pages/Paintings";
import Store from "./pages/Store";

interface Tab {
  id: number,
  path: string,
  text: string,
  element: FunctionComponent,
}

export const tabs: Tab[] = [
  {
    id: 1,
    path: "home",
    text: "Home",
    element: Home,
  },
  {
    id: 2,
    path: "paintings",
    text: "Paintings",
    element: Paintings,
  },
  {
    id: 3,
    path: "store",
    text: "Store",
    element: Store,
  },
  {
    id: 4,
    path: "biography",
    text: "Biography",
    element: Biography,
  },
]

